import {Component, OnInit} from '@angular/core';
import {FormBuilder, FormControl, FormGroup, Validators} from '@angular/forms';
import {NgxDropzoneChangeEvent} from 'ngx-dropzone';
import {CountryList} from 'src/app/address/interface/countryList';
import {AddressFunctionService} from 'src/app/address/service/address-function.service';
import {RaintreeResponse} from 'src/app/raintree/interface/raintree-response';
import {UploadImageResponse} from 'src/app/raintree/interface/upload-image/upload-image-response';
import {ContactTransmissionService} from 'src/app/raintree/transmission/contact-tresponse/contact-transmission.service';
import {ImageTransmissionService} from 'src/app/raintree/transmission/upload-image/image-transmission.service';
import {RequestMapperService} from 'src/app/request-mapper.service';
import {ToastMessageService} from 'src/app/services/toast-message.service';
import {BrowserAPIService} from "@bloomscorp/ngbase";

@Component({
	selector: 'fb-contact',
	templateUrl: './contact.component.html',
	styleUrls: ['./contact.component.scss']
})
export class ContactComponent implements OnInit {

	public showAddImagesButton: boolean = false;
	public siteKey: string = '6LcyjjgpAAAAAEKhK9w3qsodToxcryKVNfW4XKvo';
	public secretKey: string = '6LcyjjgpAAAAAGYryY5ThdvC32icaJCamTzfUP9';

	public contactForm: FormGroup<{
		name: FormControl<string | null>;
		email: FormControl<string | null>;
		productType: FormControl<string | null>;
		productDescription: FormControl<string | null>;
		quantity: FormControl<string | null>;
		deliveryDate: FormControl<number | null>;
		phone: FormControl<string | null>;
		country: FormControl<string | null>;
		company: FormControl<string | null>;
		companyWebsite: FormControl<string | null>;
		attachments: FormControl<string[] | null>;
	}> = {} as FormGroup;

	public countryList: CountryList[] = [];
	public files: File[] = [];

	public requiredErrorMessage: boolean = false;
	public selectedImage: string[] = [];
	public isFormDisabled: boolean = true;
	public isBrowser: boolean = false;

	constructor(
		public _toast: ToastMessageService,
		private _fb: FormBuilder,
		private _addressService: AddressFunctionService,
		private _uploadImageTransmission: ImageTransmissionService,
		private _contactTransmission: ContactTransmissionService,
		private _browser: BrowserAPIService
	) {
		this.contactForm = this._fb.group({
			name: ['', Validators.required],
			email: ['', [Validators.required, Validators.email]],
			productType: [''],
			productDescription: [''],
			quantity: [''],
			deliveryDate: [0],
			phone: ['', [Validators.required, Validators.minLength(7)]],
			country: ['', [Validators.required]],
			company: [''],
			companyWebsite: [''],
			attachments: [['']]
		});
	}

	public ngOnInit(): void {
		this.isBrowser = this._browser.isBrowser();

		this._addressService
			.fetchCountryList()
			.subscribe((data: any) => {
				this.countryList = data;
			});

		this.contactForm.valueChanges.subscribe(
			() => {
				this.requiredErrorMessage = false;
			}
		);
	}

	get form() {
		return this.contactForm.controls;
	}

	protected hasError(control: any): boolean | undefined {
		return this.contactForm.get(control)?.invalid &&
			(this.contactForm.get(control)?.dirty || this.contactForm.get(control)?.touched);
	}

	public onSelect(event: NgxDropzoneChangeEvent): void {
		this.files.push(...event.addedFiles);
		this.showAddImagesButton = this.files.length > 0;
	}

	public onRemove(event: File): void {
		this.files.splice(this.files.indexOf(event), 1);

		if (this.files.length == 0) {
			this.showAddImagesButton = false;
		}
	}

	public handleSuccess(evt: string): void {
		if (evt) {
			this.isFormDisabled = false;
			this._initReCaptchaExpireTimeout()
		}
	}

	public submitForm(): void {
		if (!this.isBrowser)
			return;

		if (!this.contactForm.valid) {
			this.requiredErrorMessage = true;
			return
		}

		if (this.contactForm.value.deliveryDate) {
			this.contactForm.value.deliveryDate = new Date(this.contactForm.value.deliveryDate).getTime();
		}

		this.contactForm.value.attachments = [];
		let index: number = 0;

		if (this.files.length > 0) {
			this.files.forEach((file) => {

				let convertImageToFormData = new FormData();
				convertImageToFormData.append('imageFile', file);

				this._uploadImageTransmission.uploadImage(
					convertImageToFormData,
					() => {
					},
					() => {
					},
					(response: RaintreeResponse | UploadImageResponse) => {
						this.selectedImage.push(response.imageUrl);

						if (index === (this.files.length - 1)) {
							this.contactForm.value.attachments = this.selectedImage;
							this.submitFormRequest()
						}

						index++
					},
					(error: string) => {
					},
					() => {
					}
				)
			})
		} else {
			this.submitFormRequest()
		}
	}


	public submitFormRequest(): void {
		if (!this.isBrowser)
			return;

		let formData: FormBuilder | any = this.contactForm.value;

		if (!formData.quantity) {
			formData.quantity = -1
		}

		this._contactTransmission.submit(
			RequestMapperService.CONTACT_API,
			formData,
			() => {
			},
			() => {
			},
			(response: RaintreeResponse | UploadImageResponse) => {

				this._toast.success('form submit successfully', 'We will be consulting you soon');
				this.contactForm.reset();
				this.files = []
			},
			(error: string) => {
			},
			() => {
			}
		)
	}

	public matcher(event: any): void {

		const allowedRegex: RegExp = /[0-9]/g;

		if (!event.key.match(allowedRegex)) {
			event.preventDefault();
		}
	}

	private _initReCaptchaExpireTimeout(): void {

		if (!this.isBrowser)
			return;

		setTimeout(() => {
			this.isFormDisabled = true;
		}, 60000)
	}
}
